angular.module('lf.common')

.factory('authenticationService', function ($http, $rootScope) {
  
  var authenticationService = {
    /**
     * This method submits the login credentials to the backend service that
     * authenticates the credentials returns the authentication response.
     * 
     */
    loginUser: function (params) {
      var postData = { 
        login: params.login,
        password: params.password,
        requesterId: 'singlePageCheckout'
      };
    
      return $http({
        method: 'POST',
        url: lf.data.xhr.loginAjax,
        data: $.param(postData),
        headers: { 
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
    },
    
    /**
     * This method submits the email address entered by guest user to the backend service that
     * verifies that the email address is not already registered in LeapFrog's WebCRM database
     * and initializes web session (also creates guest vindicia account).
     * 
     */
    loginGuest: function (params) {
      var postParams = {
        getData: 'guestLoginResponse',
        updateData: 'true',
        action: 'verifyUserExists',
        amplifiHandler: '/atg/userprofiling/ProfileFormHandler',
        '/atg/userprofiling/ProfileFormHandler.atg_emailAddress': params.emailAddress,
        '/atg/userprofiling/ProfileFormHandler.atg_initializeGuestWebSession': true // TODO: add an option for this
      };
      
      return $http({
        method: 'POST',
        url: lf.data.xhr.shopAction,
        params: postParams,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
    }
    
  }
  
  return authenticationService;
  
});
